/* eslint-disable no-unused-vars */
import {
  AssistanceTypeBack,
  IArea,
  ICalendarCatalog,
  ISesionCatalogType,
} from "src/app/catalog/interfaces/catalog.interface";
import { calendarUtils } from "../utils/convertDates.utils";
import { IBackNewCoursePlanningDto } from "src/app/course-planning/interfaces/course-planning";
import { ProcessIdByName } from "../constants/ProcessId";
import { ILocalization } from "./tipo-localizacion";
import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";

export enum ERpaProcessStatus {
  success = 1,
  fail = 2,
  pending = 3,
}

export interface ICalendarSessionItem {
  nombreSesion: string;
  nombreArea: string;
  idSesionCalendarioParte: number;
  fkIdSesionCalendario: number;
  fechaInicio: Date;
  fkIdProcesoSesion: ProcessIdByName;
  fkIdProcesoRpa: ERpaProcessStatus;
  fechaFin: Date;
  fechaAlta?: Date;
  asistenciaGbuIntegrada: boolean | null;
  asistenciaIntegradaSifca: boolean | null;
}

export type FormBuilderSessionType = {
  idSesionCalendario?: number;
  nivel?: string;
  nombreSession: string;
  partes: PartsCalendarSession[];
  ponentes: string;
  arrayPonentes: string;
  tipoSesion: string;
  location: ILocalization;
  idPlaneacionCurso: string;
  objectIdSesion: string | null; // LOId from cornerstone
};
export interface IPostSessionBack {
  idSesionCalendario?: number;
  nombreSesion: string;
  numeroPersona: string;
  idPlaneacionCurso: number;
  idTipoSesion: number;
  ponentes: string;
  ubicacion: string;
  objectIdSesion?: string; // External Id from LOId (Learning Object Id) from cornerstone
  idLocacion: string; //ExternalId from ILocalization from cornerstone
  nivel: string;
  fechaAlta: Date;
  idUsuario: number;
  partsCalendarSessions: PartsCalendarSession[];
  fkIdProcesoSesion?: ProcessIdByName;
  fkIdProcesoRpa?: ERpaProcessStatus;
  arrayPonentes: string;
  MasterQR?: boolean;
}

export interface ISessionBasicData {
  idSesionCalendario: number;
  nombreSesion: string;
  idPlaneacionCurso: number;
  idTipoSesion: number;
  ponentes: string;
  ubicacion: string;
  nivel: string;
  fechaAlta: Date;
  partsCalendarSessions: null | PartsCalendarSession[];
}

export interface PartsCalendarSession {
  fecha: Date;
  fechaInicio: Date;
  fechaFin: Date;
  idSesionCalendarioParte?: number;
  fkIdSesionCalendario?: number;
}

export interface PartsCalendarTimeInputObj {
  fecha: Date;
  fechaInicio: Date;
  fechaFin: Date;
  dateStruct: NgbDateStruct;
  startDateTime: NgbTimeStruct;
  endDateTime: NgbTimeStruct;
  idSesionCalendarioParte?: number;
  fkIdSesionCalendario?: number;
  isValidStart: boolean;
  isValidEnd: boolean;
  isValid: boolean;
}
function addOneHourToCurrentTime(addTwo = false) {
  const currentTime = new Date();
  const multiplier = addTwo ? 2 : 1;
  const oneHourLater = new Date(
    currentTime.getTime() + 60 * 60 * (1000 * multiplier)
  ); // Adding one hour in milliseconds
  return {
    hour: oneHourLater.getHours(),
    minute: 30,
    second: 0,
  };
}
export function addHoursToTimeToTimeStruct(time: Date, hoursToAdd: number) {
  const currentTime = time;
  const oneHourLater = new Date(
    currentTime.getTime() + 60 * 60 * (1000 * hoursToAdd)
  ); // Adding one hour in milliseconds
  return {
    hour: oneHourLater.getHours(),
    minute: currentTime.getMinutes(),
    second: 0,
  };
}
export const initSessionValues = {
  date: calendarUtils.getDateToPickerDate(),
  startDate: addOneHourToCurrentTime(),
  endDate: addOneHourToCurrentTime(true),
  idSesionCalendarioParte: 0,
  isValid: true,
};

export interface ISessionDetailsResponse {
  area: IArea;
  fechaAlta: Date;
  idArea: number;
  idPlaneacionCurso: number;
  idSesionCalendario: number;
  idTipoAsistencia: number;
  idTipoCapacitacion: number;
  idTipoSesion: number;
  idUsuario: number;
  nivel: string;
  nombreSesion: string;
  partsCalendarSessions: PartsCalendarSession[];
  planeacion: IBackNewCoursePlanningDto;
  ponentes: string;
  arrayPonentes: string;
  tipoAsistencia: AssistanceTypeBack;
  tipoCapacitacion: ICalendarCatalog;
  tipoSesion: ISesionCatalogType;
  ubicacion: string;
  idLocacion: string;
  fkIdProcesoSesion: number;
  fkIdProcesoRpa: ERpaProcessStatus;
  objectIdSesion: string; // External Id from LOId (Learning Object Id) from cornerstone
  idLocalizador: string; // ExternalId from LocationID  for QR
  asistenciaGbuIntegrada: boolean | null;
  asistenciaIntegradaSifca: boolean | null;
  masterQr?: boolean;
}
